module.exports = "function rowRenderer ({ key, index, style }) {\n  return (\n    <div\n      key={key}\n      style={style}\n    >\n      {itemsArray[index].name}\n    </div>\n  )\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/row-renderer.js
 ** module id = 379
 ** module chunks = 0
 **/